import { render, staticRenderFns } from "./DebateTabs.vue?vue&type=template&id=b1f7fc7c&scoped=true&"
import script from "./DebateTabs.vue?vue&type=script&lang=js&"
export * from "./DebateTabs.vue?vue&type=script&lang=js&"
import style0 from "./DebateTabs.vue?vue&type=style&index=0&id=b1f7fc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7fc7c",
  null
  
)

export default component.exports